import { FC } from 'react';

import { DownloadFileIcon, EyeIconSmall, ThreeDotsIcon } from '../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from '../../../../components/popover/index';
import { useLocale } from '../../../../hooks/index';

const ICON_COLOR = '#344054';

/** A file row's actions: open it, or save it — the same two the workspace browser offers. */
export const FileRowMenu: FC<{ onDownload: () => void; onView: () => void }> = ({
  onDownload,
  onView,
}) => {
  const { messagesLocale } = useLocale();

  return (
    <Popover>
      <PopoverTrigger
        aria-label={messagesLocale['MORE_ACTIONS']}
        className="flex size-6 items-center justify-center rounded bg-white"
      >
        <ThreeDotsIcon className="size-4 rotate-90" height={16} iconColor={ICON_COLOR} width={16} />
      </PopoverTrigger>
      <PopoverContent className="flex w-fit flex-col gap-[2px] rounded p-2 font-normal shadow-2xl [&>*]:font-inter">
        <PopoverClose
          className="flex w-full items-center gap-2 p-[6px] pr-8 text-sm font-normal text-gray-700 hover:bg-gray-50"
          onClick={onView}
        >
          <EyeIconSmall className="size-4" iconColor={ICON_COLOR} />
          <AppFormattedMessage id="VIEW" />
        </PopoverClose>
        <PopoverClose
          className="flex w-full items-center gap-2 p-[6px] pr-8 text-sm font-normal text-gray-700 hover:bg-gray-50"
          onClick={onDownload}
        >
          <DownloadFileIcon iconColor={ICON_COLOR} />
          <AppFormattedMessage id="DOWNLOAD" />
        </PopoverClose>
      </PopoverContent>
    </Popover>
  );
};
